export default {"src":"/_next/static/media/telegram-1.3219dee2.svg","height":96,"width":243,"blurWidth":0,"blurHeight":0};